// extracted by mini-css-extract-plugin
export default {"content":"BookPage_content__xsHap","grid":"BookPage_grid__GZwEP","preview":"BookPage_preview__cCAYB"};